<template>
  <div class="section">
    <div class="bill-no">对账单号：{{ orderInfo.purchaseNo }}</div>
    <div class="info-grid">
      <!-- 左侧信息 -->
      <div class="info-left">
        <div class="info-item">
          <span class="label">业务期间</span><span class="value">{{ orderInfo.statementPeriod }}</span>
        </div>
        <div class="info-item">
          <span class="label">经办人</span><span class="value">{{ orderInfo.handlerBy }}</span>
        </div>
        <div class="info-item">
          <span class="label">预结算日期</span><span class="value">{{ orderInfo.preClearingDate }}</span>
        </div>
        <div class="info-item">
          <span class="label">最后结算人</span><span class="value">{{ orderInfo.lastSettleBy }}</span>
        </div>
        <div class="info-item">
          <span class="label">最后结算日期</span><span class="value">{{ orderInfo.lastSettleDate }}</span>
        </div>
        <div class="info-item">
          <span class="label">创建人</span><span class="value">{{ orderInfo.createdBy }}</span>
        </div>
        <div class="info-item">
          <span class="label">创建日期</span><span class="value">{{ orderInfo.createDate }}</span>
        </div>
        <div class="info-item">
          <span class="label">备注</span><span class="value">{{ orderInfo.remarks }}</span>
        </div>
      </div>
      <!-- 右侧汇总表格 -->
      <div class="info-right">
        <el-table :data="orderInfo.groups || []" border stripe size="small">
          <el-table-column label="序号" width="60" type="index" fixed></el-table-column>
          <el-table-column prop="name" label="业务类型" min-width="120"></el-table-column>
          <el-table-column prop="count" label="单据数" min-width="100"></el-table-column>
          <el-table-column prop="amountIn" label="应收金额" min-width="130">
            <template v-slot="scope">
              <span>￥{{ scope.row.amountIn }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="amountOut" label="应付金额" min-width="130">
            <template v-slot="scope">
              <span>￥{{ scope.row.amountOut }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BillInfo",
  props: {
    orderInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
.section {
  margin-bottom: 30px;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 24px;
}
.bill-no {
  font-size: 16px;
  font-weight: 700;
  color: #333333;
  padding: 12px;
  background-color: rgb(249, 249, 249);
}
.info-grid {
  background-color: #ffffff;
  padding: 12px;
  box-sizing: border-box;
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}
.info-left {
  flex: 1 1 280px;
}
.info-right {
  flex: 2 1 400px;
}
.info-item {
  display: flex;
  padding: 6px 0;
  border-bottom: 1px dashed #e8ecf1;
}
.info-item:last-of-type {
  border-bottom: none;
}
.info-item .label {
  width: 100px;
  color: #909399;
  flex-shrink: 0;
}
.info-item .value {
  color: #303133;
  word-break: break-all;
}
</style>
